import { Component, Injector, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ApAlertService } from 'webcommon/core-ui';
import { FcOccupationListItemDto, FcModifyOccupationListItemDto } from 'webcommon/shared';
import { FcGenericItemModalBaseComponent, FcListValidationService } from '../../generic';

@Component({
  providers: [ApAlertService, FcListValidationService],
  selector: 'fc-occupation-list-modal',
  templateUrl: './fc-occupation-list-modal.component.html',
})

export class FcOccupationListModalComponent extends FcGenericItemModalBaseComponent implements OnInit {
  public override baseId = 'fc-occupation-item';

  // List Item with default value
  public listItem: FcOccupationListItemDto = {
    Id: '',
    ExternalID: '',
    OccupationCode: '',
    OccupationUid: '',
    Name: '',
    Notes: '',
    Inactive: false,
    UserDefined: true,
  };

  // Form Controls
  public externalIdControl = new FormControl();
  public occupationCodeControl = new FormControl();
  public occupationUidControl = new FormControl();
  public nameControl = new FormControl();
  public notesControl = new FormControl();
  public inactiveControl = new FormControl();
  public userDefinedControl = new FormControl();

  // Form Group
  public form = new FormGroup({
    externalID: this.externalIdControl,
    occupationCode: this.occupationCodeControl,
    occupationUid: this.occupationUidControl,
    name: this.nameControl,
    notes: this.notesControl,
    inactive: this.inactiveControl,
    userDefined: this.userDefinedControl,
  });

  constructor(injector: Injector) {
    super(injector);
  }

  override ngOnInit() {
    super.ngOnInit();

    // Load List Item and set default validation rules
    this.loadListItem({
      ExternalID: {
        MaxLength: 25,
      },
      Name: {
        IsRequired: true,
        MaxLength: 250,
      },
      OccupationCode: {
        MaxLength: 10,
      },
      Notes: {
        MaxLength: 65535,
      },
    });
  }

  public setForm(): void {
    // External Id Control
    this.externalIdControl.setValidators(this.fcListValidation.getValidators('ExternalID'));
    this.externalIdControl.setValue(this.listItem.ExternalID);

    // Occupation Code Control
    this.occupationCodeControl.setValidators(this.fcListValidation.getValidators('OccupationCode'));
    this.occupationCodeControl.setValue(this.listItem.OccupationCode);

    // Occupation Uid Control
    this.occupationUidControl.setValue(this.listItem.OccupationUid);

    // Name Control
    const isNameControlDisabled = !this.listItem.UserDefined;
    if (isNameControlDisabled) {
      this.nameControl.disable();
    }
    this.nameControl.setValidators(this.fcListValidation.getValidators('Name'));
    this.nameControl.setValue(this.listItem.Name);

    // Notes Control
    this.notesControl.setValidators(this.fcListValidation.getValidators('Notes'));
    this.notesControl.setValue(this.listItem.Notes);

    // Inactive Control
    this.inactiveControl.setValue(this.listItem.Inactive);

    // User Defined Control
    this.userDefinedControl.disable();
    this.userDefinedControl.setValue(this.listItem.UserDefined);

    this.validateForm();
  }

  public override save(): void {
    const values = this.form.getRawValue();
    const modifyItemDto: FcModifyOccupationListItemDto = {
      ExternalID: values.externalID,
      OccupationCode: values.occupationCode,
      OccupationUid: values.occupationUid,
      Name: values.name,
      Inactive: values.inactive,
      Notes: values.notes,
      UserDefined: values.userDefined,
    };
    super.save<FcModifyOccupationListItemDto>(modifyItemDto);
  }
}
